import {
  INVENTORY_COUNT_ITEM_STATUSES_DATA,
  INVENTORY_COUNT_STATUSES_DATA,
} from '../actions/actionType'

const initialState = {
  inventoryCountStatusesList: [],
  inventoryCountItemStatusesList: [],
}

export default function InventoryCountReducer(state = initialState, action) {
  switch (action.type) {
    case INVENTORY_COUNT_STATUSES_DATA:
      return { ...state, inventoryCountStatusesList: action.payload }
    case INVENTORY_COUNT_ITEM_STATUSES_DATA:
      return { ...state, inventoryCountItemStatusesList: action.payload }
    default:
      return state
  }
}
